module.exports = __webpack_public_path__ + "static/img/watermelon_th.d6dc2cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/watermelon_th.png
// module id = zCT+
// module chunks = 0